import {performRequest} from 'shared/utils';

import {IReportConfigurationAttribute} from '../report-configuration-types';

export interface IGetTableAttributesArgs {
    templateCode: string;
}
export const getTableAttributes = async (args: IGetTableAttributesArgs) => {
    const {templateCode} = args;
    const response = await performRequest<IReportConfigurationAttribute[]>({
        url: `/table-reports/lookup/columns?templateCode=${templateCode}&sourceForBlock=TABLE`,
        method: 'GET',
    });
    return response;
};

export interface IGetHeaderAttributesArgs {
    templateCode: string;
}
export const getHeaderAttributes = async (args: IGetHeaderAttributesArgs) => {
    const {templateCode} = args;
    const response = await performRequest<IReportConfigurationAttribute[]>({
        url: `/table-reports/lookup/columns?templateCode=${templateCode}&sourceForBlock=HEADER`,
        method: 'GET',
    });
    return response.data;
};
